// Landing page utility functions for content editing and management

export type UpdateContentPayload = {
  landingPageId: string;
  newText: string;
  xPath: string;
  newHtml?: string;
  replaceAsHtml?: boolean;
};

async function updateLandingPageContent(payload: UpdateContentPayload): Promise<any> {
  const hostname = typeof window !== 'undefined' ? window.location.origin : '';

  const response = await fetch('/api/landing-page/update-html', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, hostname }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    const error = new Error(errorData.error || 'Failed to update content');
    // Preserve the isRecoverableError flag from the API response
    (error as any).isRecoverableError = errorData.isRecoverableError;
    throw error;
  }

  const result = await response.json();

  // Screenshot update is now handled automatically by the API
  return result;
}

/**
 * Simple save function that handles occurrence-based updates with fallback to full HTML
 */
export async function saveLandingPageChanges({
  newText,
  landingPageId,
  xPath,
  newHtml,
  replaceAsHtml,
}: {
  newText: string;
  landingPageId: string;
  xPath: string;
  newHtml?: string;
  replaceAsHtml?: boolean;
}): Promise<void> {
  try {
    await updateLandingPageContent({
      landingPageId,
      newText,
      xPath,
      newHtml,
      replaceAsHtml,
    });
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    alert(`Error saving content: ${errorMessage}`);
    throw error;
  }
}
